import * as am5xy from "@amcharts/amcharts5/xy";




export default class ChartYaxis extends am5xy.ValueAxis<am5xy.AxisRenderer> {

    public category: string;
    public color: string = '';
}